import { scrollToTheBottom } from "../../HelperFunctions/scrollToTop";
import classes from "./SocialSideNav.module.css";
import { FaXTwitter } from 'react-icons/fa6';
import ScrollButton from "./ScrollButton";

const SocialSideNav = () => {
  return (
    <div className={classes.container}>
      <div>
        <a
          href="https://x.com/AIESECinNigeria"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clipPath="url(#clip0_194_761)">
              <path
                d="M7.55015 21.75C16.6045 21.75 21.5583 14.2467 21.5583 7.74185C21.5583 7.53092 21.5536 7.31529 21.5442 7.10435C22.5078 6.40746 23.3395 5.54425 24 4.5553C23.1025 4.9546 22.1496 5.21538 21.1739 5.32873C22.2013 4.71291 22.9705 3.74547 23.339 2.60577C22.3725 3.17856 21.3155 3.58261 20.2134 3.80061C19.4708 3.01156 18.489 2.48912 17.4197 2.31405C16.3504 2.13899 15.2532 2.32105 14.2977 2.8321C13.3423 3.34314 12.5818 4.1547 12.1338 5.14131C11.6859 6.12791 11.5754 7.23461 11.8195 8.29029C9.86248 8.19208 7.94793 7.6837 6.19997 6.79809C4.45202 5.91249 2.90969 4.66943 1.67297 3.14952C1.0444 4.23324 0.852055 5.51564 1.13503 6.73609C1.418 7.95653 2.15506 9.02344 3.1964 9.71998C2.41463 9.69516 1.64997 9.48467 0.965624 9.10591V9.16685C0.964923 10.3041 1.3581 11.4066 2.07831 12.2868C2.79852 13.1669 3.80132 13.7705 4.91624 13.995C4.19205 14.1931 3.43198 14.222 2.69484 14.0793C3.00945 15.0574 3.62157 15.9129 4.44577 16.5263C5.26996 17.1398 6.26511 17.4806 7.29234 17.5012C5.54842 18.8711 3.39417 19.6141 1.17656 19.6106C0.783286 19.61 0.390399 19.5859 0 19.5384C2.25285 20.9837 4.87353 21.7514 7.55015 21.75Z"
                fill="#1D2129"
              />
            </g>
            <defs>
              <clipPath id="clip0_194_761">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg> */}
          <FaXTwitter size={30} color="#000000" />
        </a>
      </div>
      <div>
        <a
          href="https://www.youtube.com/@aiesecinnigeria"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
          >
            <path
              d="M23.7609 4.20004C23.7609 4.20004 23.5265 2.54536 22.8047 1.8188C21.8906 0.862549 20.8687 0.857861 20.4 0.801611C17.0437 0.557861 12.0047 0.557861 12.0047 0.557861H11.9953C11.9953 0.557861 6.95624 0.557861 3.6 0.801611C3.13125 0.857861 2.10937 0.862549 1.19531 1.8188C0.473437 2.54536 0.24375 4.20004 0.24375 4.20004C0.24375 4.20004 0 6.14535 0 8.08598V9.90472C0 11.8453 0.239062 13.7907 0.239062 13.7907C0.239062 13.7907 0.473437 15.4453 1.19062 16.1719C2.10468 17.1282 3.30468 17.0953 3.83906 17.1985C5.76093 17.3813 12 17.4375 12 17.4375C12 17.4375 17.0437 17.4282 20.4 17.1891C20.8687 17.1328 21.8906 17.1282 22.8047 16.1719C23.5265 15.4453 23.7609 13.7907 23.7609 13.7907C23.7609 13.7907 24 11.85 24 9.90472V8.08598C24 6.14535 23.7609 4.20004 23.7609 4.20004ZM9.5203 12.1125V5.36723L16.0031 8.7516L9.5203 12.1125Z"
              fill="#1D2129"
            />
          </svg>
        </a>
      </div>
      <div>
        <a
          href="https://www.instagram.com/aiesecinnigeria"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M12 2.97148C15.2062 2.97148 15.5859 2.98554 16.8469 3.04179C18.0187 3.09336 18.6515 3.29023 19.0734 3.45429C19.6312 3.66992 20.0344 3.93242 20.4515 4.34961C20.8734 4.77148 21.1312 5.16992 21.3469 5.72773C21.5109 6.1496 21.7078 6.7871 21.7593 7.95429C21.8156 9.21991 21.8297 9.5996 21.8297 12.8012C21.8297 16.0074 21.8156 16.3871 21.7593 17.648C21.7078 18.8199 21.5109 19.4527 21.3469 19.8746C21.1312 20.4324 20.8687 20.8355 20.4515 21.2527C20.0297 21.6746 19.6312 21.9324 19.0734 22.148C18.6515 22.3121 18.014 22.509 16.8469 22.5605C15.5812 22.6168 15.2015 22.6308 12 22.6308C8.79374 22.6308 8.41405 22.6168 7.15312 22.5605C5.98124 22.509 5.34843 22.3121 4.92656 22.148C4.36874 21.9324 3.96562 21.6699 3.54843 21.2527C3.12656 20.8308 2.86875 20.4324 2.65312 19.8746C2.48906 19.4527 2.29218 18.8152 2.24062 17.648C2.18437 16.3824 2.17031 16.0027 2.17031 12.8012C2.17031 9.59491 2.18437 9.21522 2.24062 7.95429C2.29218 6.78241 2.48906 6.1496 2.65312 5.72773C2.86875 5.16992 3.13125 4.76679 3.54843 4.34961C3.97031 3.92773 4.36874 3.66992 4.92656 3.45429C5.34843 3.29023 5.98593 3.09336 7.15312 3.04179C8.41405 2.98554 8.79374 2.97148 12 2.97148ZM12 0.810547C8.74218 0.810547 8.33437 0.824609 7.05468 0.880859C5.77968 0.937109 4.90312 1.14336 4.14375 1.43867C3.35156 1.74805 2.68125 2.15586 2.01562 2.82617C1.34531 3.49179 0.937499 4.16211 0.628124 4.9496C0.332812 5.71367 0.126562 6.58554 0.0703124 7.86054C0.0140625 9.14491 0 9.55272 0 12.8105C0 16.0683 0.0140625 16.4762 0.0703124 17.7558C0.126562 19.0308 0.332812 19.9074 0.628124 20.6668C0.937499 21.459 1.34531 22.1293 2.01562 22.7949C2.68125 23.4605 3.35156 23.873 4.13906 24.1777C4.90312 24.473 5.77499 24.6793 7.04999 24.7355C8.32968 24.7918 8.73749 24.8058 11.9953 24.8058C15.2531 24.8058 15.6609 24.7918 16.9406 24.7355C18.2156 24.6793 19.0922 24.473 19.8515 24.1777C20.639 23.873 21.3093 23.4605 21.975 22.7949C22.6406 22.1293 23.0531 21.459 23.3578 20.6715C23.6531 19.9074 23.8593 19.0355 23.9156 17.7605C23.9718 16.4808 23.9859 16.073 23.9859 12.8152C23.9859 9.55741 23.9718 9.1496 23.9156 7.86991C23.8593 6.59492 23.6531 5.71835 23.3578 4.95898C23.0625 4.16211 22.6547 3.49179 21.9844 2.82617C21.3187 2.16055 20.6484 1.74805 19.8609 1.44336C19.0969 1.14805 18.225 0.941797 16.95 0.885547C15.6656 0.824609 15.2578 0.810547 12 0.810547Z"
              fill="#1D2129"
            />
            <path
              d="M12 6.64648C8.59687 6.64648 5.83594 9.40742 5.83594 12.8105C5.83594 16.2137 8.59687 18.9746 12 18.9746C15.4031 18.9746 18.164 16.2137 18.164 12.8105C18.164 9.40742 15.4031 6.64648 12 6.64648ZM12 16.809C9.79218 16.809 8.00156 15.0183 8.00156 12.8105C8.00156 10.6027 9.79218 8.81211 12 8.81211C14.2078 8.81211 15.9984 10.6027 15.9984 12.8105C15.9984 15.0183 14.2078 16.809 12 16.809Z"
              fill="#1D2129"
            />
            <path
              d="M19.8468 6.40269C19.8468 7.19956 19.2 7.84175 18.4078 7.84175C17.6109 7.84175 16.9687 7.19487 16.9687 6.40269C16.9687 5.60581 17.6156 4.96362 18.4078 4.96362C19.2 4.96362 19.8468 5.6105 19.8468 6.40269Z"
              fill="#1D2129"
            />
          </svg>
        </a>
      </div>
      <div>
        <a
          href="https://www.linkedin.com/company/aiesec-in-nigeria"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
          >
            <path
              d="M7.38 9.77953C8.98 9.77953 10.26 8.47953 10.26 6.89953C10.26 5.31953 8.96 4.01953 7.38 4.01953C5.8 4.01953 4.5 5.31953 4.5 6.89953C4.5 8.47953 5.8 9.77953 7.38 9.77953ZM13 11.9595V27.9995H17.96V20.0795C17.96 17.9795 18.36 15.9595 20.94 15.9595C23.52 15.9595 23.52 18.3595 23.52 20.1995V27.9995H28.5V19.1995C28.5 14.8795 27.58 11.5595 22.54 11.5595C20.12 11.5595 18.5 12.8795 17.84 14.1395H17.78V11.9395H13.02L13 11.9595ZM4.9 11.9595H9.88V27.9995H4.9V11.9595Z"
              fill="#1D2129"
            />
          </svg>
        </a>
      </div>
      {/* <div onClick={scrollToTheBottom}>
        <p>SCROLL DOWN</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="23"
          viewBox="0 0 8 23"
          fill="none"
        >
          <path
            d="M3.64645 22.3536C3.84171 22.5488 4.15829 22.5488 4.35355 22.3536L7.53553 19.1716C7.7308 18.9763 7.7308 18.6597 7.53553 18.4645C7.34027 18.2692 7.02369 18.2692 6.82843 18.4645L4 21.2929L1.17157 18.4645C0.976312 18.2692 0.659729 18.2692 0.464467 18.4645C0.269205 18.6597 0.269205 18.9763 0.464467 19.1716L3.64645 22.3536ZM3.5 2.18557e-08L3.5 22L4.5 22L4.5 -2.18557e-08L3.5 2.18557e-08Z"
            fill="#A0A0A0"
          />
        </svg>
      </div> */}
      <div>
        <ScrollButton />
      </div>
    </div>
  );
};

export default SocialSideNav;
